import React from "react";
import {
  FilePenLine,
  FileText,
  FileUser,
  FilePlus,
  FileLock,
  FileSearch2,
} from "lucide-react";

type MeetingType =
  | "regular"
  | "special"
  | "executive"
  | "informational"
  | "worksession"
  | "other";

interface MeetingIconProps {
  type: MeetingType | string;
  className?: string;
  size?: number;
  color?: string;
}

export const MeetingIcon: React.FC<MeetingIconProps> = ({
  type,
  className = "",
  size = 20,
  color = "currentColor",
}) => {
  const iconProps = { className, size, color };

  switch (type) {
    case "regular":
      return <FileText {...iconProps} />;
    case "special":
      return <FilePlus {...iconProps} />;
    case "executive":
      return <FileLock {...iconProps} />;
    case "informational":
      return <FileSearch2 {...iconProps} />;
    case "worksession":
      return <FilePenLine {...iconProps} />;
    default:
      return <FileUser {...iconProps} />; // fallback
  }
};
